import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { filter, firstValueFrom } from 'rxjs';
import { approvalsHardPrerequisitesMet } from 'src/app/common/menu-def.provider';
import { ERROR_URL } from 'src/app/app/app.constants';
import { UPSELL_REGISTRY } from 'src/app/pages/upgrade/upsell-registry';
import { GrowthBookService } from 'src/app/services/growthbook/service';
import { AuthState } from 'src/app/store/auth/auth.state';

/**
 * Guards /approvals with plan-aware access:
 * - Basic + flag on → upgrade upsell
 * - Basic + flag off → unauthorized
 * - Hard guardrail fail → unauthorized
 * - Otherwise → allow through to report
 */
export const approvalsSetupRedirectGuard: CanActivateFn = async () => {
  const store = inject(Store);
  const router = inject(Router);
  const errorUrl = inject(ERROR_URL);
  const growthbook = inject(GrowthBookService);

  await firstValueFrom(growthbook.initialized.pipe(filter(x => x)));

  const config = UPSELL_REGISTRY.get('approvals');
  const company = store.selectSnapshot(AuthState.company);

  if (company.pricingPlan?.includes('basic')) {
    const flagOn = !!growthbook.getFeatureValue(config?.featureFlagKey, null);
    return flagOn
      ? router.createUrlTree(['/upgrade', 'approvals'])
      : router.createUrlTree([errorUrl, 'unauthorized']);
  }

  if (!approvalsHardPrerequisitesMet(company)) {
    return router.createUrlTree([errorUrl, 'unauthorized']);
  }

  return true;
};
